/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlanChartData } from './planChartData';


export interface SplineRequestDTO { 
    slider: SplineRequestDTO.SliderEnum;
    sliderValue: number;
    dataPoints: Array<PlanChartData>;
}
export namespace SplineRequestDTO {
    export type SliderEnum = 'sales' | 'orders' | 'roas' | 'cpo';
    export const SliderEnum = {
        Sales: 'sales' as SliderEnum,
        Orders: 'orders' as SliderEnum,
        Roas: 'roas' as SliderEnum,
        Cpo: 'cpo' as SliderEnum
    };
}


